var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCibi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_874_9061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_874_9061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30039 20.4001V18.0001H2.40039V16.2001H9.30039C9.78372 16.2001 10.2046 16.3793 10.5629 16.7376C10.9212 17.0959 11.1004 17.5168 11.1004 18.0001V20.4001H9.30039ZM12.9004 20.4001V18.0001C12.9004 17.5168 13.0766 17.0959 13.4291 16.7376C13.7816 16.3793 14.2054 16.2001 14.7004 16.2001H21.6004V18.0001H14.7004V20.4001H12.9004ZM6.60039 15.0001C5.75039 15.0001 5.03789 14.7126 4.46289 14.1376C3.88789 13.5626 3.60039 12.8501 3.60039 12.0001V8.4001H20.4004V12.0001C20.4004 12.8501 20.1087 13.5626 19.5254 14.1376C18.9421 14.7126 18.2337 15.0001 17.4004 15.0001H6.60039ZM6.60039 13.2001H17.4004C17.7404 13.2001 18.0254 13.0851 18.2554 12.8551C18.4854 12.6251 18.6004 12.3401 18.6004 12.0001V10.2001H5.40039V12.0001C5.40039 12.3401 5.51539 12.6251 5.74539 12.8551C5.97539 13.0851 6.26039 13.2001 6.60039 13.2001ZM3.60039 7.2001V5.4001H9.00039V4.5001C9.00039 4.26676 9.08424 4.05843 9.25194 3.8751C9.41966 3.69176 9.62747 3.6001 9.87539 3.6001H14.1254C14.3587 3.6001 14.5629 3.69176 14.7379 3.8751C14.9129 4.05843 15.0004 4.26676 15.0004 4.5001V5.4001H20.4004V7.2001H3.60039Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCibi);
export default __webpack_public_path__ + "static/media/cibi.dab2216d15592b94bfc59d96825b8758.svg";
export { ForwardRef as ReactComponent };